const readOnly = (atom) => {
    const set = async () => {
        throw new Error('selected atom does not support set');
    };
    return {
        ...atom,
        set,
    };
};
export default readOnly;
